// Maps a backend service name (VytalModel IntegrationServices, returned by
// /Integration/GetIntegrations) to the camelCased key of the GetIntegrationTokens
// response and to the Integrations i18n namespace key.
export const INTEGRATION_SERVICES: {
  service: string;
  tokenKey: string;
  i18nKey: string;
}[] = [
  { service: 'ventopay', tokenKey: 'ventopay', i18nKey: 'ventopay' },
  { service: 'kamasys', tokenKey: 'kamasys', i18nKey: 'kamasys' },
  { service: 'sides', tokenKey: 'sides', i18nKey: 'sides' },
  { service: 'circlecube', tokenKey: 'circlecube', i18nKey: 'circlecube' },
  {
    service: 'eurekantine.de',
    tokenKey: 'eurekantine',
    i18nKey: 'eurekantine',
  },
  { service: 'qnips', tokenKey: 'qnips', i18nKey: 'qnips' },
  { service: 'itslolly', tokenKey: 'itslolly', i18nKey: 'itslolly' },
  { service: 'other', tokenKey: 'other', i18nKey: 'other' },
  { service: 'test', tokenKey: 'test', i18nKey: 'test' },
];

export type IntegrationEntry = {
  service: string;
  displayName: string | null;
  isCustom: boolean;
  createdAt: string;
  // Only present for custom integrations
  reminderWebhookUrl: string | null;
  returnWebhookUrl: string | null;
  invoiceWebhookUrl: string | null;
  apiKeyIsSet: boolean;
};

export type GetIntegrationsResponse = {
  addedIntegrations: IntegrationEntry[];
  availableServices: string[];
  devFeaturesEnabled: boolean;
};

// Custom-integration tokens from /Merchant/GetIntegrationTokens (customTokens array)
export type CustomIntegrationToken = {
  service: string;
  displayName: string | null;
  token: string;
};
